import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.25 18.769a60 60 0 0 1 15.797 2.1 1.146 1.146 0 0 0 1.453-1.095v-1.005M3.75 4.519v.75a.75.75 0 0 1-.75.75h-.75m0 0v-.375c0-.622.504-1.125 1.125-1.125H20.25m-18 1.5v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.503 1.125 1.125v9.75c0 .62-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125v-.375m1.5 1.5v-.75a.75.75 0 0 0-.75-.75h-.75m12.75-4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m3 0h.008v.007H18zm-12 0h.008v.007H6z"
    }, null, -1)
  ])))
}
export default { render: render }